import React from 'react';

function getId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return (match && match[2].length === 11)
    ? match[2]
    : null;
}

const ResponsiveVideo = ({url}) => {
  const videoId = getId(url);
  return !!videoId && videoId.length > 0 && <iframe width="560" height="315" src={`//www.youtube.com/embed/${videoId}`} frameBorder="0" allowFullScreen></iframe>;
}

export default ResponsiveVideo;